<template>
    <el-row class="reOrdForm">
        <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>发布工单</span>
              </div>
              <div class="mains">
                <el-form ref="ordForm" :model="ordForm"  label-width="80px" label-position="left" >
                    <el-form-item label="工单类型" prop="type">
                        <el-select v-model="ordForm.type" @change="typeChange">
                            <el-option v-for="item in typeOption" :label="item.text" :value="item.value" :key="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备型号" v-if="!isShow" prop="goods_model">
                        <!-- <el-input v-model="ordForm.goods_model"></el-input> -->
                        <el-select
                            v-model="ordForm.goods_model"
                            clearable
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入型号关键词"
                            :remote-method="remoteMethod"
                            :loading="modelLoading">
                            <el-option
                              v-for="item in modelOptions"
                              :key="item.id"
                              :label="item.model"
                              :value="item.model">
                            </el-option>
                          </el-select>
                    </el-form-item>
                    <el-form-item label="选择部门" v-if="isShow" prop="goods_category_id">
                        <el-select v-model="ordForm.goods_category_id" @change="categoryChange">
                            <el-option v-for="item in department" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="ordForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="工单详情" prop="detail">
                        <el-input  type="textarea" v-model="ordForm.detail" placeholder="你要实现什么功能？你的操作步骤是什么?你遇到的问题是:"></el-input>
                    </el-form-item>
                    <el-form-item prop="uploadImg" label="上传图片">
                          <el-upload
                            :action="action"
                            header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                            list-type="picture-card"
                            :auto-upload="true"
                            :file-list="filsList"
                            :limit="9"
                            :before-upload="beforeAvatarUpload"
                            :on-change="imgHandleChange"
                            :on-success="imgSuccess"
                            ref="pictureUpload"
                            >
                              <i slot="default" class="el-icon-plus"></i>
                              <div slot="file" slot-scope="{file}">
                                <img
                                  class="el-upload-list__item-thumbnail"
                                  :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                                  <span
                                    class="el-upload-list__item-preview"
                                    @click="handlePictureCardPreview(file)"
                                  >
                                    <i class="el-icon-zoom-in"></i>
                                  </span>
                                  <span
                                    v-if="!disabled"
                                    class="el-upload-list__item-delete"
                                    @click="imgHandleRemove(file)"
                                  >
                                    <i class="el-icon-delete"></i>
                                  </span>
                                </span>
                              </div>
                          </el-upload>
                          <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                          </el-dialog>
                    </el-form-item>
                    <el-form-item  prop="uploadFile"  label="视频/文件">
                          <el-upload
                            class="upload-demo"
                            :action="action"
                            header="Content-Type:application/x-www-form-urlencoded;charset=utf-8"
                            :auto-upload="true"
                            :on-preview="fileHandlePreview"
                            :on-remove="fileHandleRemove"
                            multiple
                            :limit="3"
                            :before-upload="beforeFileUpload"
                            :on-exceed="fileHandleExceed"
                            :on-change="fileHandleChange"
                            :on-success="fileSuccess"
                            on-error="fileError"
                            accept="doc,docx,ppt,pptx,pdf,txt,xls"
                            ref="dmtUploadFile"
                            :file-list="fileList2">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传doc,docx,ppt,pptx,pdf,txt,xls,mp4,avi,mov文件，且不超过7M</div>
                          </el-upload>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <el-button type="primary" @click="commitEvent" :loading="isLoading"  style="width: 20%;">提交</el-button>
                    </el-form-item>
                </el-form>
              </div>
        </el-card>
    </el-row>
</template>

<script>
import { getOrderType,setOrder,departTable,removeAttach,modelSelect } from '../../utils/api'
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
export default {
  components: {},
  props: {},
  data() {
    return {
      isShow:false,
      isLoading:false,
      // action:'https://dev.ebyte.com/open/api/v1/attach/uploader?user_token='+localStorage.getItem('user_token'),
      action:localStorage.getItem('uploadUrl')+localStorage.getItem('user_token'),
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      filsList:[],
      fileList2:[],
      imgList:[],
      ordForm:{
            type:'',
            goods_model:'',
            goods_category_id:'',
            goods_category_name:'',
            title:'',
            detail:'',
            attach_image:[],
            attach_file:[],
        },
        typeOption:[],
        department:[],
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
        modelOptions:[],
        modelLoading:false
    };
  },
  watch: {
    // "ordForm.goods_model"(value){
    //   if(value !== '' || value !== undefined){
    //     this.ordForm.goods_category_id = ''
    //     this.ordForm.goods_category_name = ''
    //   }
    // },
    // "ordForm.goods_category_id"(value){
    //   if(value !== '' || value !== undefined){
    //       this.ordForm.goods_model = ''
    //   }
    // }
  },
  computed: {},
  methods: {
    getOrdType(){
        var that = this
        getOrderType()
        .then(res=>{
            that.typeOption = []
            if(res.message.status == 'success'){
                res.data.forEach((item)=>{
                    that.typeOption.push({text:item.type,value:item.type})
                })
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },

    //获取易价通一级分类
    getCategoryTable(){
      departTable()
      .then(res=>{
        console.log(res,'一级分类');
        if(res.message.status == 'success'){
          this.department = res.data
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    

    ddDepart(){
      dd.ready(function(){
        dd.biz.contact.departmentsPicker({
          title:"选择部门",            //标题
          corpId:this.$store.state.ticket.corpId,              //企业的corpId
          multiple:false,            //是否多选
          limitTips:"超出了",          //超过限定人数返回提示
          maxDepartments:100,            //最大选择部门数量
          pickedDepartments:[],          //已选部门
          disabledDepartments:[],        //不可选部门
          requiredDepartments:[],        //必选部门（不可取消选中状态）
          appId:this.$store.state.ticket.agentId,              //微应用的Id
          permissionType:"GLOBAL",          //选人权限，目前只有GLOBAL这个参数
          onSuccess: function(result) {
            console.log(result,'result');
              /**
              {
                  userCount:1,                              //选择人数
                  departmentsCount:1，//选择的部门数量
                  departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
              }
              */
          },
          onFail : function(err) {}
        });
      })
    },

    //图片上传
    //移除图片
    imgHandleRemove(file) {
      // var that = this
      // let uploadFiles = this.$refs.pictureUpload.uploadFiles
      // for (var i = 0; i < uploadFiles.length; i++) {
      //   if (uploadFiles[i]['url'] == file.url) {
      //     uploadFiles.splice(i, 1)
      //   }
      // }
      // console.log(file,'file');
      // console.log(that.imgList,'that.imgList');
      // that.imgList.forEach((item,index)=>{
      //   if(item == file.response.data[0].url){
      //     that.imgList.splice(index,1)
      //   }
      // })
      console.log(file);
      var urlValue = file.response.data[0].url
      console.log('12123123');
      var that = this
      var params = {
        url:urlValue
      }
      removeAttach(params)
          .then(res=>{
            console.log(res,'删除附件');
            if(res.message.status == 'success'){
              that.$message.success('删除成功')
              let uploadFiles = that.$refs.pictureUpload.uploadFiles
              for (var i = 0; i < uploadFiles.length; i++) {
                if (uploadFiles[i]['url'] == file.url) {
                  uploadFiles.splice(i, 1)
                }
              }
              that.imgList.forEach((item,index)=>{
                if(item == file.response.data[0].url){
                  that.imgList.splice(index,1)
                }
              })
            }else{
              console.log(res.message.text);
            }
          })
          .catch(err=>{
            console.log(err,'删除附件');
          })

    },
    beforeAvatarUpload(file){
        const isLt5M = file.size / 1024 / 1024 < 5;

        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
        }
        return  isLt5M;
    },
    // imgRemove(file, fileList){
    //   console.log(file,'imgRemove我是移除的钩子函数');
    //   console.log(fileList,'fileListimgRemove');
    // },
    //放大图片
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    // 图片状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    imgHandleChange(file){
        // console.log(file,'asdasasd');
    },
    //图片上传成功的钩子
    imgSuccess(res, file, fileList){
        console.log(res,'res上传图片成功的返回');
        var that = this
        if(res.message.status == 'success'){
          // that.ordForm.attach_image +=  res.data[0].url + ','
          that.imgList.push(res.data[0].url)
          that.$message.success('上传成功')
        }else{
          that.$message.error('上传失败')
          that.$refs.pictureUpload.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
        }
    },


    //文件上传
    fileHandlePreview(file){
      console.log(file);
    },
    //文件限制
    beforeFileUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 7;
      // if(!isLt7M){
      //   this.$message.error('上传文件大小不能超过 7MB!')
      //   return isLt7M
      // }
    },
    fileHandleRemove(file, fileList){
      // var that = this
      // console.log(file, '我是删除人间file');
      // console.log(fileList,'我是删除文件');
      // that.fileList2.forEach((item,index)=>{
      //   if(item == file.response.data[0].url){
      //     that.fileList2.splice(index,1)
      //   }
      // })
      // console.log(that.fileList2,'that.fileList2');
      var that = this
      var urlValue = file.response.data[0].url
      var params = {
        url:urlValue
      }
      removeAttach(params)
      .then(res=>{
        console.log(res,'res删除文件');
        if(res.message.status == 'success'){
          that.$message.success('删除成功')
          that.fileList2.forEach((item,index)=>{
            if(item == file.response.data[0].url){
              that.fileList2.splice(index,1)
            }
          })
        }else{
          console.log(res.message.text);
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },
    fileBeforeRemove(file, fileList){
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //超出文件限制
    fileHandleExceed(files, fileList){
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    fileHandleChange(file){
      console.log(file,'文件');
    },
    fileSuccess(res, file, fileList){
      console.log(fileList,'fileList');
      console.log(res,'res');
      console.log(file,'file');
      var that = this
      if(res.message.status == 'success'){
          that.fileList2.push(res.data[0].url)
      }else{
        that.$message.error(res.message.text)
        console.log( that.fileList2,'that.fileList2');
        that.$refs.dmtUploadFile.uploadFiles.splice(that.$refs.dmtUploadFile.uploadFiles.indexOf(res), 1);
      }
    },
    fileError(err, file, fileList){
      console.log(err,'err');
    },

    typeChange(value){
      if(value == '技术支持'){
          this.isShow = false
      }else{
          this.isShow = true
      }
    },
    categoryChange(e){
      var that = this
      that.department.forEach(item=>{
        if(item.id == e){
          that.ordForm.goods_category_name = item.name
        }
      })
      console.log(e,'categoryChange');
    },
    //提交表单
    commitEvent(){
        var that = this
        that.isLoading = true
        console.log(that.ordForm,'order');
        var  imgStr = that.imgList.join(',')
        var  fileStr = that.fileList2.join(',')
        var params = {
          type :that.ordForm.type,
          goods_model:that.ordForm.goods_model,
          goods_category_id:that.ordForm.goods_category_id,
          goods_category_name:that.ordForm.goods_category_name,
          title:that.ordForm.title,
          detail:that.ordForm.detail,
          attach_image:imgStr,
          attach_file:fileStr
        }
        setOrder(params)
        .then(res=>{
          console.log(res,'提交表单');
          if(res.message.status == 'success'){
              that.$refs['ordForm'].resetFields();
              that.$refs['pictureUpload'].uploadFiles = []
              that.fileList2 = []
              that.imgList = []
              that.$message.success('提交成功')
              that.$router.push({name:'reFormResult',params:{data:res.data}})
              that.isLoading = false
          }else{
            if(res.message.text == 'invalid goods category'){
                that.$message.error('请输入正确的型号')
            }else if(res.message.text == 'title require verify fail : title can not empty'){
                that.$message.error('请输入标题')
            }else if(res.message.text == 'detail require verify fail : detail can not empty'){
                that.$message.error('请输入详情')
            }else{
                that.$message.error(res.message.text)
            }
            that.isLoading = false
          }
        })
        .catch(err=>{
            that.$message.error(err)
            that.isLoading = false
            console.log(err,'err');
        })
    },
    //型号模糊查询触发
    remoteMethod(value){
      console.log('促发了');
      this.modelOptions = []
      if(value !== ''){
        this.modelLoading = true;
        var params = {
          model:value
        }
        modelSelect(params)
        .then(res=>{
          console.log(res,'模糊查询结果');
          if(res.message.status == 'success'){
            this.modelOptions = res.data
            this.modelLoading = false
          }else{
            this.modelLoading = false
            this.$message.error(res.message.text)
          }
        })
        .catch(err=>{
          this.$message.error(err)
          this.modelLoading = false
          console.log(err);
        })
      }else{
        this.modelOptions = []
      }
    },

    
  },
  created() {},
  mounted() {
    console.log(localStorage.getItem('uploadUrl'),'localStorage.getItem(uploadUrl)');
    this.getOrdType()
    // this.ddConfig()
    // this.ddDepart()
    this.getCategoryTable()
  }
};
</script>
<style lang="scss" scoped>
 ::v-deep  .mains{
    width: 100%;
    .el-textarea__inner{
      height: 220px;
    }
}

</style>
